import { message } from 'antd';
import Handlebars from 'handlebars';

//@ts-ignore
import stickerTemplate from '../handlebars/sticker.hbs';
import { ParcelService } from '../services';
import dayjs from 'dayjs';
import { Constants } from '@shared/constants';
import { useCallback } from 'react';


export const usePrintParcelSticker = () => {
    return useCallback(
        async (id: string | number) => {
            message.loading('Sticker hazırlanır.');
            try {
                const template = await fetch(stickerTemplate).then((r) => r.text());
                const result = await ParcelService.getWeight(id);

                if (result.status === 200) {
                    const renderedTemplate = Handlebars.compile(template)({
                        data: result.data,
                        checkDate: dayjs().format(Constants.DATE)
                    });

                    const printWindow = window.open();

                    if (printWindow) {
                        printWindow.document.write(renderedTemplate);
                        printWindow.document.close();
                    } else {
                        message.error('Brauzerdə xəta baş verdi.');
                    }
                } else {
                    message.error(result.data);
                }
            } catch (e) {
                message.error('Şablon əldə edilə bilmədi.');
            }
        }, [])
};
